<template>
  <Content>
    <form @submit.prevent="submitForm">
      <div class="container-fluid py-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 class="page-title mb-1">{{ currentLang.title }}</h3>
            <p class="page-subtitle mb-0">
              {{ currentLang.detail }}
            </p>
          </div>
          <div class="d-inline-flex gap-3 px-3" >
            <button v-if="isEdit"
              @click="$router.push(`/product/${route.params.id}/chapter`)"
              class="btn btn-light back-btn"
            >
              {{ currentLang.chapters }}
            </button>

            <button
              @click="$router.push('/products')"
              class="btn btn-light back-btn"
            >
              {{ currentLang.back }}
            </button>
          </div>
        </div>
        <ErrorAlert v-if="errorMessage" :message="errorMessage" />

        <div class="row g-4">
          <div v-if="isEdit" class="col-12 mt-4">
            <label class="custom-label">{{ currentLang.images }}</label>

            <!-- گالری تصاویر موجود (از سرور) -->
            <div class="row g-3">
              <div
                v-for="img in existingImages"
                :key="img.id"
                class="col-6 col-md-3"
              >
                <div class="position-relative">
                  <img
                    :src="img.url"
                    class="img-fluid rounded border"
                    style="height: 120px; width: 100%; object-fit: cover"
                  />
                  <button
                    type="button"
                    @click="deleteImage(img)"
                    class="btn btn-danger btn-sm position-absolute top-0 end-0"
                  >
                    ×
                  </button>
                </div>
              </div>

              <!-- دکمه آپلود جدید -->
              <div class="col-6 col-md-3">
                <div
                  class="upload-area h-100 border border-dashed rounded d-flex align-items-center justify-content-center"
                  @click="$refs.fileInput.click()"
                  style="cursor: pointer; min-height: 120px"
                >
                  <span class="text-muted">+ {{ currentLang.addImage }}</span>
                  <input
                    type="file"
                    ref="fileInput"
                    hidden
                    @change="handleFileChange"
                    accept="image/*"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.name_fa }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderNameFa"
              v-model="form.name_fa"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.name_en }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderNameEn"
              v-model="form.name_en"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.price_irr }}
              <span class="required">*</span>
            </label>

            <input
              type="number"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderPriceIrr"
              v-model="form.price_irr"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.price_usd }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderPriceUsd"
              v-model="form.price_usd"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.description_fa }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderDescriptionFa"
              v-model="form.description_fa"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.description_en }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderDescriptionEn"
              v-model="form.description_en"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.stock_total }}
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderStockTotal"
              v-model="form.stock_total"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.status }}
              <span class="required">*</span>
            </label>

            <select class="form-select custom-input" v-model="form.status">
              <option value="active">{{ currentLang.statusActive }}</option>
              <option value="inactive">{{ currentLang.statusInActive }}</option>
            </select>
          </div>

          <!-- دسته بندی -->
          <div class="col-12 col-md-6">
            <label class="custom-label">{{ currentLang.category }}</label>
            <input
              class="form-control custom-input"
              list="list-categories"
              :value="categoryName"
              @input="handleInput('category', $event.target.value)"
              @change="syncCategory()"
            />
            <datalist id="list-categories">
              <option v-for="c in categories" :key="c.id" :value="c.title" />
            </datalist>
          </div>

          <!-- چک‌باکس جدید -->
          <div v-if="!isEdit" class="col-12 col-md-6">
            <div class="form-check mt-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="is_book"
                v-model="form.is_book"
              />
              <label class="form-check-label" for="isActive">
                {{ currentLang.placeholderIsBook || currentLang.yes }}
              </label>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-5">
          <button class="btn save-btn" :disabled="loading">
            {{ loading ? currentLang.saving : currentLang.save }}
          </button>
        </div>
      </div>
    </form>
  </Content>
</template>
<script setup>
import { alertStore } from "@/stores/alertStore";
import Content from "@/components/AdminContent.vue";
import { lang } from "@/plugins/lang";
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@/plugins/axios";
import ErrorAlert from "@/components/alerts/ErrorAlert.vue";
const errorMessage = ref("");
const route = useRoute();
const router = useRouter();
const isEdit = computed(() => !!route.params.id);
const categories = ref([]);
import enText from "@/locales/en/productForm";
import faText from "@/locales/fa/productForm";
import { showLoading, hideLoading } from "@/stores/loading";

const translations = {
  en: enText,
  fa: faText,
};
const currentLang = computed(() => translations[lang.value]);

const loading = ref(false);

const categoryName = ref("");
let timers = { category: null };
const existingImages = ref([]);

const form = ref({
  name_fa: "",
  name_en: "",
  price_irr: "",
  price_usd: "",
  stock_total: "",
  stock_reserved: "",
  stock_visible: "",
  description_fa: "",
  description_en: "",
  status: "active",
  category_id: "",
  is_book: "false",
});

const submitForm = async () => {
  try {
    loading.value = true;
    showLoading();


    const response = isEdit.value
      ? await api.patch(`admin/products/${route.params.id}`, form.value)
      : await api.post("admin/products", form.value);

    if (response.status === 201 || response.status === 200) {
      alertStore.trigger(
        "success",
        currentLang.value.success,
        response?.data?.message || ""
      );
      router.push("/products");
    } else {
      errorMessage.value = response?.data?.message || "networkError";
    }
  } catch (error) {
    errorMessage.value = error.response.data.message || "networkError";
  } finally {
    loading.value = false;
    hideLoading();

  }
};

const getProduct = async () => {
  try {
    loading.value = true;
    showLoading();

    const response = await api.get(`admin/products/${route.params.id}`);
    const product = response.data.data;
    form.value.name_fa = product.name_fa;
    form.value.name_en = product.name_en;
    form.value.price_irr = product.price_irr;
    form.value.price_usd = product.price_usd;
    form.value.stock_total = product.stock_total;
    form.value.description_fa = product.description_fa;
    form.value.description_en = product.description_en;
    form.value.is_book = product.is_book;
    form.value.status = product.status;
    form.value.category_id = product.category?.id || "";
    categoryName.value = product.category?.title || "";
    existingImages.value = product.images || [];
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
    hideLoading();

  }
};

const onSearch = async (query) => {
  let url = "";
  url = `admin/categories/list?title=${query}`;

  const res = await api.get(url);
  categories.value = res.data.data;
};

const handleInput = (type, val) => {
  categoryName.value = val;
  form.value.category = "";
  clearTimeout(timers[type]);
  timers[type] = setTimeout(() => onSearch(val), 400);
};

const syncCategory = async () => {
  let list = [];
  list = categories.value;
  const searchTerm = categoryName.value;
  const item = list.find((i) => i.title === searchTerm);

  if (item) {
    form.value.category_id = item.id;
  }
};

onMounted(() => {
  onSearch("");
  if (route.params.id) {
    getProduct();
  }
});

const deleteImage = async (image) => {
  try {
    await api.delete(`admin/products/${route.params.id}/images/${image.id}`); // فرض بر مسیر حذف
    existingImages.value = existingImages.value.filter(
      (i) => i.id !== image.id
    );
  } catch (e) {
    alertStore.trigger("error", "خطا در حذف تصویر");
  }
};

const uploadNewImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("product_id", route.params.id);

  try {
    const res = await api.post(
      `admin/products/${route.params.id}/images`,
      formData,
      {
        headers: {
          "Content-Type": null,
        },
      }
    );
    // بعد از موفقیت، لیست existingImages را آپدیت کنید
    existingImages.value.push(res.data.data);
  } catch (error) {
    const errors = error.response?.data?.message || "خطا در آپلود تصویر";
    const validationErrors = error.response?.data?.errors;
    let displayMessage = errors;

    if (validationErrors && typeof validationErrors === "object") {
      // تبدیل خطاهای ولیدیشن به یک متن واحد
      displayMessage = Object.values(validationErrors).flat().join(", ");
    }
    errorMessage.value = displayMessage;
  }
};

const handleFileChange = async (event) => {
  const files = Array.from(event.target.files);
  for (const file of files) {
    await uploadNewImage(file); // یکی‌یکی آپلود می‌کنیم یا همزمان
  }
};
</script>


<style scoped>
.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
}

.page-subtitle {
  color: #64748b;
  font-size: 14px;
}

.custom-label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.custom-input {
  height: 48px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  padding: 0 14px;
  transition: 0.2s ease;
  background: #fff;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.custom-input:focus {
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08),
    0 0 0 3px rgba(59, 130, 246, 0.15);

  outline: none;
}

.save-btn {
  min-width: 160px;
  height: 46px;
  border: none;
  border-radius: 10px;
  background: #16a34a;
  color: white;
  font-weight: 600;
  padding: 0 24px;
  transition: 0.2s ease;

  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
}

.save-btn:hover {
  background: #15803d;
  color: white;
}

.back-btn {
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  background: #ffffff;
  color: #334155;
  font-weight: 600;
  transition: 0.2s ease;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.back-btn:hover {
  background: #f8fafc;
  color: #0f172a;

  transform: translateY(-1px);

  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
}

.custom-input:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 22px;
  }

  .save-btn {
    width: 100%;
  }
}
.required {
  color: red;
  margin-right: 4px;
}
</style>